// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { TFunction } from 'i18next';
import { ByTenant, CollectHistory } from './Types';
import { getFormatDateWithCurrentTimezone } from 'ts/formatDate';
import { DATE_FORMAT } from './ConstantValues';

/**
 * @returns CSV data of deliveries weight and count grouped by tenant
 */
export const getCollectHistoryCSVDataGroupedByTenant = (params: {
  type: 'delivered' | 'received';
  data: CollectHistory;
  targetIds: string[];
  byTenant: ByTenant;
  wasteUnitName: string | undefined;
  exportDatetimeString: string;
  t: TFunction<'translation', undefined, 'translation'>;
}) => {
  const {
    type,
    data,
    targetIds,
    exportDatetimeString,
    t,
    byTenant,
    wasteUnitName,
  } = params;

  const result = [
    [
      t('histories.label_csv_export_datetime') || '出力日時',
      exportDatetimeString,
    ],
    [
      type === 'delivered'
        ? t('histories.label_csv_delivery_date_time') || '配送日時'
        : t('histories.label_csv_received_date_time') || '受領日時',
      type === 'delivered'
        ? data.deliveredDatetime
          ? getFormatDateWithCurrentTimezone(
              data.deliveredDatetime,
              DATE_FORMAT.slaYMDHm
            )
          : ''
        : data.receivedDatetime
        ? getFormatDateWithCurrentTimezone(
            data.receivedDatetime,
            DATE_FORMAT.slaYMDHm
          )
        : '',
    ],
    [t('histories.label_csv_emissions_site_name') || '拠点名', data.areaName],
    [
      t('histories.label_csv_export_waste_unit') || '出力対象品目',
      wasteUnitName,
    ],
    [
      t('histories.label_csv_tenant_name') || 'テナント名',
      (t('common_history_field.weight') || '重量') + ' (kg)',
      t('histories.label_csv_register_count') || '登録回数',
    ],
  ];

  const byTenantArray = Object.values(byTenant).sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  // if there is no relation to tenant data, add a row with empty tenant name that shows the total weight and count
  if (byTenantArray.length === 0) {
    result.push(['', data.weight.toString(), targetIds.length.toString()]);

    result.push([
      t('common.total') || '',
      data.weight.toString(),
      targetIds.length.toString(),
    ]);

    return result;
  }

  let weightSum = 0;
  let countSum = 0;

  for (const tenantData of byTenantArray) {
    result.push([
      tenantData.name,
      tenantData.weight,
      tenantData.count.toString(),
    ]);

    weightSum += Number(tenantData.weight);
    countSum += tenantData.count;
  }

  result.push([
    t('common.total') || '',
    weightSum.toString(),
    countSum.toString(),
  ]);

  return result;
};
